import React, { useState, useEffect } from "react";
import axios from "axios";
import CommonReportLayout from "./CommonReportLayout";
import { REACT_APP_API_URL } from "../../../../env";

const InventoryReport = () => {
  const [data, setData] = useState([]);
  const [requestBy, setRequestBy] = useState("");
  const [requestByList, setRequestByList] = useState([]);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Load Dropdown
  useEffect(() => {
    loadRequestBy();
  }, []);

  const loadRequestBy = async () => {
    try {
      // Static dropdown
      setRequestByList([
        { label: "Head Office", value: 1 },
        { label: "TIC", value: 2 },
        { label: "Hotel", value: 3 }
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch Report Data
  const fetchData = async () => {
    try {
      const payload = {
        requestBy,
        fromDate,
        toDate
      };

      const res = await axios.post(
        `${REACT_APP_API_URL}api/inventory-report/inventory`,
        payload
      );

      setData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="col-sm-12">
        <h3 className="fw-bold px-lg-4">Inventory Details Report</h3>
      </div>

      <CommonReportLayout
        title="Inventory Report"
        onShow={fetchData}
        filters={
          <>
            <div className="col-md-3">
              <label>Request By</label>
              <select
                className="form-control"
                value={requestBy}
                onChange={(e) => setRequestBy(e.target.value)}
              >
                <option value="">-- All --</option>

                {requestByList.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-3">
              <label>From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <label>To Date</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
          </>
        }
      >
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>SL</th>
              <th>Req No</th>
              <th>Requested By</th>
              <th>Unit Name</th>
              <th>Location</th>
              <th>Total</th>
              <th>Dispatch</th>
              <th>Receive</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((item, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{item.ReqIndentNo}</td>
                  <td>{item.OrderBy}</td>
                  <td>{item.Name}</td>
                  <td>{item.LocationName}</td>
                  <td>{item.NoOfItems || 0}</td>
                  <td>{item.NoOfItemsDisp || 0}</td>
                  <td>{item.NoOfItemRcv || 0}</td>
                  <td>{item.ReqDate}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </CommonReportLayout>
    </>
  );
};

export default InventoryReport;